module.exports = __webpack_public_path__ + "b19d5ceaac41d6064fbd7152f224fde1.png";